module.exports = __webpack_public_path__ + "static/media/springleaf.950046f1.webp";